import { TLocale } from 'src/lib/constants';
import { NAVIGATION_EVENTS } from 'src/lib/trackingEvents';
import type { NavData } from './types';

const enUS: NavData = {
  items: [
    {
      title: 'Products',
      type: 'tabs',
      id: 'lxt5t4AA9i',
      plainTabList: true,
      tabListLink: {
        title: 'All products',
        href: '/products/',
      },
      featured: {
        title: 'Featured',
        image: {
          title: 'Smarter models. More ways to build.',
          description: `Explore what's new across lending, fraud, payments, and more.`,
          href: '/whats-new/fall-2026/',
          image: 'featured',
          cta: `See what's new`,
          trackingId: 'nav.featured',
        },
      },
      children: [
        {
          title: 'Payments',
          type: 'rows',
          id: 'tab-payments',
          children: [
            {
              title: 'Payments',
              children: [
                {
                  title: 'Auth',
                  description: 'Verified account & routing numbers',
                  href: '/products/auth/',
                  icon: 'Institution',
                },
                {
                  title: 'Balance',
                  description: 'Real-time balance checks',
                  href: '/products/balance/',
                  icon: 'LineGraph',
                },
                {
                  title: 'Identity',
                  description: 'Bank account-holder information',
                  href: '/products/identity/',
                  icon: 'Identity',
                },
                {
                  title: 'Signal',
                  description: 'ACH risk assessment and scoring',
                  href: '/products/signal/',
                  icon: 'Shield',
                },
                {
                  title: 'Transfer',
                  description: 'Payment processing',
                  href: '/products/transfer/',
                  icon: 'Transfer',
                },
                {
                  title: 'Investments Move',
                  description: 'Streamline asset transfers',
                  href: '/products/investments-move/',
                  icon: 'ChevronRightDouble',
                },
                {
                  title: 'Guarantee',
                  description: 'Managed payment and risk solution',
                  href: '/products/guaranteed-payments/',
                  icon: 'ClearedRec',
                },
                {
                  title: 'Database Auth',
                  description: 'Database account verification',
                  href: '/products/database-auth/',
                  icon: 'List',
                },
              ],
            },
          ],
        },
        {
          title: 'Fraud & risk',
          type: 'rows',
          id: 'woApIPPvlI',
          children: [
            {
              title: 'Fraud & risk',
              children: [
                {
                  title: 'Protect',
                  description: 'Detect and respond to fraud risk',
                  href: '/products/protect/',
                  icon: 'ProductProtect',
                },
                {
                  title: 'Identity',
                  description: 'Bank account-holder information',
                  href: '/products/identity/',
                  icon: 'Identity',
                },
                {
                  title: 'Identity Verification',
                  description: 'Global KYC and anti-fraud',
                  href: '/products/identity-verification/',
                  icon: 'ProductIdv',
                },
                {
                  title: 'Signal',
                  description: 'ACH risk assessment and scoring',
                  href: '/products/signal/',
                  icon: 'Shield',
                },
                {
                  title: 'Monitor',
                  description: 'AML watchlist screening',
                  href: '/products/monitor/',
                  icon: 'ProductMonitor',
                },
                {
                  title: 'Cash Advance Index',
                  description: 'Network-powered risk decisions',
                  href: '/products/cash-advance-index/',
                  icon: 'Income',
                },
              ],
            },
          ],
        },
        {
          title: 'Financial management',
          type: 'rows',
          id: '1yZaEee8MO',
          children: [
            {
              title: 'Financial management',
              children: [
                {
                  title: 'Transactions',
                  description: 'Up to 24 months of categorized data',
                  href: '/products/transactions/',
                  icon: 'ProductTransactions',
                },
                {
                  title: 'Investments',
                  description: 'Retirement, brokerage, & crypto data',
                  href: '/products/investments/',
                  icon: 'LineGraph',
                },
                {
                  title: 'Liabilities',
                  description: 'Credit card and mortgage data',
                  href: '/products/liabilities/',
                  icon: 'BarGraph',
                },
                {
                  title: 'Enrich',
                  description: 'Categorize internal transactions',
                  href: '/products/enrich/',
                  icon: 'Tag',
                },
              ],
            },
          ],
        },
        {
          title: 'Credit underwriting',
          type: 'rows',
          id: '3Mym4W6dN2',
          children: [
            {
              title: 'Credit underwriting',
              children: [
                {
                  title: 'Underwriting',
                  description:
                    'Use cash flow data for more accurate underwriting',
                  href: '/check/underwriting/',
                  icon: 'ItemManagement',
                },
                {
                  title: 'Income verification',
                  description:
                    'Verify income instantly with real time bank data',
                  href: '/check/income/',
                  icon: 'Wallet',
                },
                {
                  title: 'LendScore',
                  description:
                    'Go beyond standard insights with a new risk score',
                  href: '/check/lendscore/',
                  icon: 'Progress',
                },
              ],
            },
          ],
        },
        {
          title: 'Onboarding',
          type: 'rows',
          id: 'etJDyIv8t9',
          children: [
            {
              title: 'Onboarding',
              children: [
                {
                  title: 'Link',
                  description:
                    'Industry-leading bank connections for 12,000+ institutions',
                  href: '/plaid-link/',
                  image: 'link',
                  mobileOverride: { icon: 'Link' },
                },
                {
                  title: 'Layer',
                  description:
                    'Capture identity, contact, and bank info in a single click',
                  href: '/layer/',
                  image: 'layer',
                  mobileOverride: { icon: 'Platform' },
                },
              ],
            },
          ],
        },
        {
          title: 'Open finance',
          type: 'rows',
          id: 'lr9EnWoBqg',
          children: [
            {
              title: 'Open finance',
              children: [
                {
                  title: 'Core exchange',
                  description: 'Industry-aligned API connectivity',
                  href: '/products/core-exchange/',
                  icon: 'Webhooks',
                },
                {
                  title: 'Permissions Manager',
                  description: 'Consumer permissions management',
                  href: '/products/permissions-manager/',
                  icon: 'StepComplete',
                },
                {
                  title: 'App Directory',
                  description: 'Manage risk and compliance',
                  href: '/products/app-directory/',
                  icon: 'BookOpen',
                },
              ],
            },
          ],
        },
      ],
    },
    {
      id: 'main-menu-item-002',
      type: 'tabs',
      title: 'Solutions',
      plainTabList: true,
      tabListGradient: true,
      children: [
        {
          id: 'k9bGMoUZlj',
          type: 'list',
          title: 'By use case',
          children: [
            {
              title: 'Open Finance',
              description: 'Connect to financial data through a single API',
              href: '/use-cases/open-finance/',
              icon: 'Globe',
            },
            {
              title: 'Fraud & risk prevention',
              description: 'Detect & prevent fraud across your user base',
              href: '/use-cases/fraud-and-risk-prevention/',
              icon: 'Shield',
            },
            {
              title: 'Onboarding & identity verification',
              description: 'Instantly onboard new users & verify identities',
              href: '/use-cases/instant-onboarding-identity-verification/',
              icon: 'Identity',
            },
            {
              title: 'KYC & AML compliance',
              description: 'Manage compliance & mitigate risk',
              href: '/use-cases/kyc-aml-compliance/',
              icon: 'Users',
            },
            {
              title: 'Outbound Bank Payments',
              description: 'Send faster, more reliable bank payouts',
              href: '/use-cases/outbound-bank-payments/',
              icon: 'Logout',
            },
            {
              title: 'Inbound bank payments',
              description: 'Accept more successful bank payments',
              href: '/use-cases/inbound-bank-payments/',
              icon: 'Login',
            },
            {
              title: 'Business financial management',
              description: 'Power tools for modern business finance',
              href: '/use-cases/business-financial-management/',
              icon: 'BarGraph',
            },
            {
              title: 'Personal financial management',
              description: 'Deliver tailored insights to improve finances',
              href: '/use-cases/personal-financial-insights/',
              icon: 'PieChart',
            },
            {
              title: 'Billing & recurring payments',
              description: 'Boost successful payments for more revenue',
              href: '/industries/billing-recurring-payments/',
              icon: 'Refresh',
            },
            {
              title: 'Earned wage access',
              description: 'Offer early access to wages',
              href: '/use-cases/earned-wage-access/',
              icon: 'Income',
            },
          ],
        },
        {
          id: 'pk68Pi5WR4',
          type: 'list',
          title: 'By industry',
          compact: true,
          children: [
            {
              title: 'AI companies',
              href: '/industries/ai/',
              icon: 'AiIndustry',
            },
            {
              title: 'Auto',
              href: '/industries/auto/',
              icon: 'Car',
            },
            {
              title: 'Banks & credit unions',
              href: '/industries/banks-credit-unions/',
              icon: 'Institution',
            },
            {
              title: 'Gaming',
              href: '/industries/gaming/',
              icon: 'Dice',
            },
            {
              title: 'Consumer lending',
              href: '/industries/consumer-lending/',
              icon: 'ItemManagement',
            },
            {
              title: 'Insurance',
              href: '/industries/insurance/',
              icon: 'Insurance',
            },
            {
              title: 'Government & public sector',
              href: '/industries/government-public-sector/',
              icon: 'Buildings',
            },
            {
              title: 'Healthcare',
              href: '/industries/healthcare/',
              icon: 'Healthcare',
            },
            {
              title: 'Mortgage',
              href: '/industries/mortgage/',
              icon: 'Home',
            },
            {
              title: 'Platforms & marketplaces',
              href: '/industries/platforms-marketplaces/',
              icon: 'Platform',
            },
            {
              title: 'Property management',
              href: '/industries/property-management/',
              icon: 'Key',
            },
          ],
        },
      ],
    },
    {
      id: 'main-menu-item-005',
      type: 'list',
      title: 'Developers',
      columns: 2,
      children: [
        {
          title: 'Quickstart',
          href: '/docs/quickstart/',
          icon: 'ChevronRightDouble',
        },
        {
          title: 'Documentation',
          href: '/docs/',
          icon: 'Docs',
        },
        {
          title: 'Libraries',
          href: '/docs/api/libraries/',
          icon: 'Libraries',
        },
        {
          title: 'GitHub',
          href: 'https://github.com/plaid',
          icon: 'Webhooks',
        },
        {
          title: 'Product demos',
          href: '/demo/',
          image: 'linkDemo',
        },
      ],
    },
    {
      id: 'main-menu-item-006',
      type: 'columns',
      title: 'Resources',
      children: [
        {
          title: 'For builders',
          children: [
            {
              title: 'Blog',
              href: '/blog/',
              icon: 'Notebook',
            },
            {
              title: 'Library',
              href: '/resources/library/',
              icon: 'Libraries',
            },
            {
              title: 'Industry resources',
              href: '/resources/',
              icon: 'NewWindow',
            },
            {
              title: 'Customer stories',
              href: '/customer-stories/',
              icon: 'Message',
            },
            {
              title: 'Events',
              href: '/events/',
              icon: 'Calendar',
            },
            {
              title: 'Intelligent finance',
              href: '/intelligent-finance/',
              icon: 'Lightbulb',
            },
          ],
        },
        {
          title: 'For users',
          children: [
            {
              title: 'What is Plaid',
              href: '/what-is-plaid/',
              icon: 'PlaidLogo',
            },
            {
              title: 'Troubleshoot connection',
              href: '/trouble-connecting/',
              icon: 'Help',
            },
            {
              title: 'Trust and safety',
              href: '/trust-safety/',
              icon: 'Shield',
            },
            {
              title: 'Connect your data',
              href: '//my.plaid.com/',
              icon: 'Integrations',
            },
            {
              title: 'Plaid Check Consumer Help Center',
              href: '/check/consumer-service-center/',
              icon: 'Identity',
            },
          ],
        },
        {
          title: 'Featured',
          stories: [
            {
              title: 'How Affirm is creating the future of digital lending',
              href: '/customer-stories/affirm/',
              image: 'affirm',
            },
            {
              title: 'How Robinhood unlocked $100M in instant funds',
              href: '/customer-stories/robinhood/',
              image: 'robinhood',
            },
            {
              title: 'How Chime boosted account funding by 300%',
              href: '/customer-stories/chime/',
              image: 'chime',
            },
          ],
          seeAllLink: {
            title: 'See all customer stories',
            href: '/customer-stories/',
          },
        },
      ],
    },
    {
      id: 'main-menu-item-004',
      title: 'Pricing',
      href: '/pricing/',
      trackingId: NAVIGATION_EVENTS.PRIMARY.USER_CLICKED_PRIMARY_NAV_PRICING,
    },
  ],
  ctaTrackingIds: {
    getAPIkeys: NAVIGATION_EVENTS.PRIMARY.GET_API_KEYS_BUTTON,
  },
};

export const navData: Partial<Record<TLocale, NavData>> = {
  'en-us': enUS,
};
